import type { Store } from 'react-redux';
import type { Request, Response as ExpressResponse } from 'express';
import type { History } from 'history';

export type universalRouterProps = {
  store: Store;
  isServer?: boolean;
  res?: ExpressResponse;
  req?: Request;
};

export type HistoryState = {
  /* to define whether it should update the route component or not */
  shouldUpdate?: boolean;
} & Record<string, any>;

export type RouterHistory = History<HistoryState>;
export class Location {
  readonly pathname: string = '/';
  readonly key?: string = '';
  readonly search?: string = '';
  readonly hash?: string = '';
  readonly state?: HistoryState = { shouldUpdate: true };
  readonly protocol?: string = '';
  constructor(init?: Partial<Location>) {
    Object.assign(this, init);
  }
}

export type CustomRouteContext = {
  shouldResolveOnServer: boolean;
  params: Record<string, string | number>;
  query: Record<string, any>;
  res?: ExpressResponse;
  req?: Request;
};
